import { MdPhone } from 'react-icons/md'
import { RiMapPinFill } from 'react-icons/ri'
import { useHistory } from 'react-router'
import Collapse from 'rc-collapse'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { CLASSIFICATION_SQUARES } from '../../../constants/classificationsStore'
import { formatCNPJ } from '../../../lib/format'
import { formatToBR } from '../../../utils/date'
import { getExtractResource } from '../../../integration/resources/extract/requests'
import Avatar from '../Avatar/Avatar'
import Button from '../Button/Button'
import Flex from '../Flex/Flex'
import LoadingBounce from '../LoadingBounce/LoadingBounce'
import routes from '../../../config/routes'
import styles from './walletListItem.module.scss'
import Text from '../Text/Text'

const WalletListItemHeader = ({ wallet, history }) => (
  <>
    <Flex>
      <Avatar image={wallet.image} title={wallet.nameFantasy} size="medium" />
      <Flex column style={{ marginLeft: 10 }}>
        <Text color="gray" variation="dark" size="md" bold>
          {wallet.nameFantasy}
        </Text>
        <Text color="gray" variation="light" size="xs" bold>
          TAB {wallet.tabNumber}
        </Text>
      </Flex>
    </Flex>

    <Button
      type="secondary"
      width="160px"
      buttonType="button"
      className={styles.button}
      onClick={() => history.push(routes.extract.generate(wallet.walletCode))}
    >
      VER EXTRATO
    </Button>
  </>
)

WalletListItemHeader.propTypes = {
  wallet: PropTypes.shape({
    nameFantasy: PropTypes.string,
    tabNumber: PropTypes.string,
    image: PropTypes.string,
    walletCode: PropTypes.number
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
}

const WalletListItem = ({ wallet }) => {
  const [extract, setExtract] = useState()
  const [open, setOpen] = useState()
  const [squares, setSquares] = useState([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const handleGetExtract = async (key) => {
    setOpen(key)
    if (!key) return

    try {
      setLoading(true)
      const {
        store: {
          cnpj,
          addressStreet,
          addressNumber,
          addressNeighborhood,
          addressCity,
          addressUf,
          nameOwner,
          phoneNumber,
          phoneNumberDdd
        },
        indicators: { classifications }
      } = await getExtractResource(wallet.walletCode)
      const addressComplete = `${addressStreet}, ${addressNumber} - ${addressNeighborhood} - ${addressCity} - ${addressUf}`

      const classificationsFiltered = classifications.filter(
        (classification) =>
          classification.value &&
          typeof classification.value === 'string' &&
          classification.value.trim() !== '' &&
          CLASSIFICATION_SQUARES.includes(classification.identifier)
      )

      if (classificationsFiltered) setSquares(classificationsFiltered)

      setExtract({
        addressComplete,
        cnpj,
        nameOwner,
        phoneNumber,
        phoneNumberDdd
      })
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const selectRenderType = (item) => {
    switch (item.identifier) {
      case 62:
        return (
          <div className={styles.containerRating}>
            <Text color="white">{item.value}</Text>
          </div>
        )

      case 66: {
        const color = item.value === 'ATIVO' ? 'quaternary' : 'primary'
        return (
          <Text color={color} variation="dark">
            {item.value}
          </Text>
        )
      }

      default:
        return (
          <Text
            size="sm"
            color="gray"
            variation="dark"
            extraBold
            margin="16px 0px"
          >
            {item.value}
          </Text>
        )
    }
  }

  return (
    <>
      <Collapse
        accordion
        className={styles.container}
        onChange={handleGetExtract}
      >
        <Collapse.Panel
          header={<WalletListItemHeader wallet={wallet} history={history} />}
          showArrow={false}
          headerClass={styles.headerCollapse}
        >
          {loading ? (
            <Flex flex="1" alignItems="center" justifyContent="center">
              <LoadingBounce />
            </Flex>
          ) : (
            <Flex>
              <Flex flex="1" column style={{ maxWidth: 300, marginRight: 80 }}>
                <Text
                  color="gray"
                  variation="dark"
                  size="xxs"
                  margin="10px 0px"
                >
                  {formatCNPJ(extract?.cnpj)}
                </Text>
                <Flex>
                  <div className={styles.containerIcon}>
                    <RiMapPinFill size={24} />
                  </div>
                  <Text color="gray" variation="dark" size="xxs">
                    {extract?.addressComplete}
                  </Text>
                </Flex>
              </Flex>

              <Flex flex="1" column>
                <Flex alignItems="center">
                  <Text
                    color="gray"
                    variation="dark"
                    size="md"
                    margin="10px 0px"
                  >
                    {extract?.nameOwner}
                  </Text>
                </Flex>
                <Flex alignItems="center">
                  <div className={styles.containerIcon}>
                    <MdPhone size={20} />
                  </div>
                  <Text color="gray" variation="dark" size="xxs">
                    +55 {`${extract?.phoneNumberDdd} ${extract?.phoneNumber}`}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          )}
        </Collapse.Panel>
      </Collapse>
      {!loading && open && squares.length > 0 && (
        <div className={styles.containerCards}>
          {squares.map((item) => (
            <div className={styles.card} key={item.identifier}>
              <Text size="xxs" color="gray" variation="dark" bold>
                {item.name}
              </Text>

              {selectRenderType(item)}

              <Text size="xxs" color="gray" variation="light" font="custom">
                {formatToBR(item?.referenceAt)}
              </Text>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

WalletListItem.propTypes = {
  wallet: PropTypes.shape({
    nameFantasy: PropTypes.string,
    tabNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image: PropTypes.string,
    walletCode: PropTypes.number
  }).isRequired
}

export default React.memo(WalletListItem)
